import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[inputTime]',
  standalone: false,
})
export class TimepickerDirective {
  private previousInput: string = '';

  private regexpList: RegExp[] = [
    /^([0-9](:([0-5]([0-9]( ([A|P](M)?)?)?)?)?)?)?$/i, // for input: 6:00 AM
    /^(0([0-9](:([0-5]([0-9]( ([A|P](M)?)?)?)?)?)?)?)?$/i, // for input: 06:00 AM
    /^(1([0-2](:([0-5]([0-9]( ([A|P](M)?)?)?)?)?)?)?)?$/i, // for input: 10:00 AM
  ]

  constructor(private _el: ElementRef) { }

  isMatch(listOfRegexps: RegExp[] , textForValidate: string):boolean {
    return listOfRegexps.some(regexp => regexp.test(textForValidate))
  }

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    let inputValue = this._el.nativeElement.value;
    let isValidInput = this.isMatch(this.regexpList, inputValue);
    if (!isValidInput) {
      inputValue = inputValue.substring(0,inputValue.length-1) + ':' + inputValue.slice(-1);
    }
    isValidInput = this.isMatch(this.regexpList, inputValue);
    this._el.nativeElement.value = isValidInput ? inputValue : this.previousInput;

    if ( inputValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }

    this.previousInput = this._el.nativeElement.value;
  }
}
